import React, { Component, Fragment } from 'react';
import { Modal, Input, Form, Select, message, Icon, Switch, Radio, Button, Divider } from 'antd';

import { SettingsWrapper } from './style';

const { Option } = Select;

class WalletModal extends Component {
	state = {
		url: this.props.modalData.webhook,
		isMax: false,
		manualSweepType: 'toMaster'
	};

	componentDidMount() {
		if (
			this.props.modalType === 'settings' ||
			this.props.modalType === 'webhook'
		) {
			const { setFields } = this.props.form;
			setFields({
				url: {
					value: this.props.webhook
				}
			});
		}
	}

	handleMax = () => {
		const { balance } = this.props;
		const { setFieldsValue } = this.props.form;
		this.setState({ isMax: !this.state.isMax }, () => {
			setFieldsValue({
				amount: this.state.isMax ? balance : 0
			});
		});
	};

	handleOk = () => {
		const { getFieldValue } = this.props.form;
		const { modalType, isRipple, handleOk, balance } = this.props;
		const { isMax } = this.state;
		if (modalType === 'webhook') {
			const body = {
				url: getFieldValue('url')
			};
			handleOk(body, modalType);
		} else if (modalType === 'withdraw') {
			let isError = false;
			const amount = getFieldValue('amount');
			if (amount === undefined || amount === '' || amount === '0') {
				return;
			}
			if (amount) {
				isError = parseFloat(balance) <= parseFloat(amount) && !isMax;
			}
			if (isError) {
				message.warn('You are trying to withdrawals exceed amount.');
				return;
			}
			const body = {
				address: getFieldValue('address'),
				amount: amount,
				priority: getFieldValue('priority')
			};
			if (isRipple) {
				body.tag = getFieldValue('tag');
			}
			if (isMax) {
				body.amount = null;
			}
			handleOk(body, modalType);
		}
	};

	handleWebhook = () => {
		const { getFieldValue } = this.props.form;
		const { modalData } = this.props;
		const body = {
			url: getFieldValue('url')
		};
		modalData.handleWebhook(body, 'webhook');
	};

	sweepManualType = (e) => {
		this.setState({ manualSweepType: e.target.value });
	};

	handleSweepManual = () => {
		const { getFieldValue } = this.props.form;
		const { modalData, master } = this.props;
		const body = {
			address: this.state.manualSweepType === 'toMaster'
				? master
				: getFieldValue('sweepAddress')
		};
		modalData.requestSweep(body, 'manual');
	};

	handleSweep = (value) => {
		this.props.modalData.requestSweep({ auto_sweep: value }, 'auto');
	};

	handleReStart = () => {
		this.props.modalData.requestRefresh();
	};

	renderModal = () => {
		const { modalType, isRipple, balance, modalData, autoSweep } = this.props;
		const { getFieldDecorator, getFieldValue } = this.props.form;
		const { isMax, manualSweepType } = this.state;
		let isError = false;
		if (modalType === 'withdraw') {
			if (getFieldValue('amount')) {
				isError =
					parseFloat(balance) <= parseFloat(getFieldValue('amount')) &&
					!isMax;
			}
		}
		if (modalType === 'webhook') {
			return (
				<div>
					<p>Programmatically react to alerts.</p>
					{getFieldDecorator(
						'url',
						{}
					)(<Input placeholder="Webhook URL" />)}
				</div>
			);
		}
		if (modalType === 'withdraw') {
			return (
				<div>
					<p>
						<b>Destination Address</b>
						{getFieldDecorator(
							'address',
							{}
						)(<Input placeholder="Destination Address" />)}
					</p>
					{isRipple ? (
						<p>
							<b>Destination Tag</b>
							{getFieldDecorator(
								'tag',
								{}
							)(<Input placeholder="Destination Tag" />)}
						</p>
					) : null}
					<p>
						<b>Amount</b>
						{getFieldDecorator(
							'amount',
							{}
						)(
							<Input
								disabled={isMax}
								placeholder="Amount"
								suffix={
									<span
										onClick={this.handleMax}
										style={{ cursor: 'pointer', color: '#0000ff' }}
									>
										MAX
									</span>
								}
							/>
						)}
						{isError ? (
							<span style={{ color: 'red' }}>
								You are trying to withdrawals exceed amount.
							</span>
						) : (
								''
							)}
						{isMax ? (
							<p style={{ display: 'flex' }}>
								<Icon
									type="info-circle"
									style={{ paddingTop: '4px' }}
								/>
								<span style={{ color: '#999' }}>
									You’ve selected to transfer the maximum from this
									account. Automatically a blockchain transaction fee
									will be subtracted from the displayed amount
								</span>
							</p>
						) : null}
					</p>
					<p>
						<b>Fee</b>
						{getFieldDecorator('priority', {
							initialValue: 'optimal'
						})(
							<Select style={{ display: 'block', width: '100%' }}>
								<Option value="optimal">Optimal (Recommended)</Option>
								<Option value="low">Low priority</Option>
								<Option value="min">
									Minimum (use the minimum network fee)
								</Option>
							</Select>
						)}
					</p>
				</div>
			);
		}
		if (modalType === 'settings') {
			return (
				<SettingsWrapper>
					<div>
						<h3>
							<b>Auto sweep</b>
						</h3>
						<div>Sweeping uses the minimal transaction fee</div>
						<div className="settings-sweep">
							<h3
								className={
									!autoSweep
										? "switch-text switch-text-active"
										: "switch-text"
								}
							>
								Off
							</h3>
							<Switch onChange={this.handleSweep} checked={autoSweep} />
							<h3
								className={
									autoSweep
										? "switch-text switch-text-active"
										: "switch-text"
								}
							>
								On
							</h3>
							<div className="sweep-description">
								Auto sweep will automatically sweep any funds that were deposited in your sub address into the master address
							</div>
						</div>
					</div>
					<div style={{ marginTop: '1rem' }}>
						<h3>
							<b>Manually sweep</b>
						</h3>
						<div>
							<Radio.Group onChange={this.sweepManualType} value={manualSweepType}>
								<Radio style={{ display: 'block', marginBottom: '0.25rem' }} value={'toMaster'}>
									Sweep to master address
								</Radio>
								<Radio style={{ display: 'block', marginBottom: '0.25rem' }} value={'toAddress'}>
									Sweep to a specific address
								</Radio>
							</Radio.Group>
							{(manualSweepType === 'toAddress')
								? <div style={{ marginTop: '1rem', maxWidth: '250px' }}>
									{getFieldDecorator(
										'sweepAddress',
										{}
									)(<Input placeholder="Address" />)}
								</div>
								: null
							}
							<div>
								<Button
									className="settings-btn"
									size='small'
									type="primary"
									disabled={
										manualSweepType === 'toAddress' &&
										!getFieldValue('sweepAddress')
									}
									onClick={this.handleSweepManual}
								>
									Sweep
								</Button>
							</div>
						</div>
					</div>
					{this.props.type === 'multi'
						? <Fragment>
							<Divider />
							<div>
								<h3>
									<b>Webhook</b>
								</h3>
								<div style={{ maxWidth: '300px' }}>
									<p>Programmatically react to alerts.</p>
									{getFieldDecorator(
										'url',
										{}
									)(<Input placeholder="Webhook URL" />)}
								</div>
								<div>
									<Button
										className="settings-btn"
										size='small'
										type="primary"
										disabled={!getFieldValue('url')}
										onClick={this.handleWebhook}
									>
										Set
									</Button>
								</div>
							</div>
						</Fragment>
						: null
					}
					<Divider />
					<div>
						<h3>
							<b>Restart Wallet</b>
						</h3>
						Restarting your wallet may help fix issues with your wallet
						<div>
							<Button
								className="settings-btn"
								size='small'
								type="primary"
								onClick={this.handleReStart}
							>
								Restart
							</Button>
						</div>
					</div>
					<Divider />
					<div>
						<h3>
							<b>Delete Wallet</b>
						</h3>
						This will delete your wallet. Make sure you have a backup of your wallet before deleting
						<div>
							<Button
								className="settings-btn"
								size='small'
								type="danger"
								onClick={modalData.onDelete}
							>
								Delete
							</Button>
						</div>
					</div>
				</SettingsWrapper>
			);
		}
		return <div>{modalType}</div>;
	};

	render() {
		const { visible, handleCancel, modalType } = this.props;
		let modalTitle = '';
		let rest = {};
		switch (modalType) {
			case 'webhook':
				modalTitle = 'Add Webhook';
				break;
			case 'withdraw':
				modalTitle = 'withdraw';
				break;
			case 'settings':
			default:
				modalTitle = 'Wallet Settings';
				rest = { footer: null };
				break;
		}
		return (
			<Modal
				visible={visible}
				title={modalTitle}
				onOk={() => {
					this.handleOk();
				}}
				onCancel={handleCancel}
				{...rest}
			>
				{this.renderModal()}
			</Modal>
		);
	}
}

const WrappedWalletModal = Form.create({ name: 'Wallet Form' })(WalletModal);

export default WrappedWalletModal;
